import type { Action, ThunkAction } from '@reduxjs/toolkit';
import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { inspectionApi } from './apis';
import { modalSlice } from './slices/modalSlice';
// import { inspectionSlice } from "../features/inspection/inspectionSlice";

const rootReducer = combineSlices(modalSlice, inspectionApi);
export type RootState = ReturnType<typeof rootReducer>;

export const makeStore = (preloadedState?: Partial<RootState>) => {
  const store = configureStore({
    reducer: rootReducer,

    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware({
        serializableCheck: {
          // Only ignore what's absolutely necessary
          ignoredActions: ['modal/addFooterAction'],
          ignoredPaths: ['modal.footerActions'],
        },
      }).concat(inspectionApi.middleware);
    },

    devTools: process.env.NODE_ENV !== 'production',
    preloadedState,
  });

  setupListeners(store.dispatch);

  return store;
};

export const store = makeStore();
export type AppStore = typeof store;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ThunkReturnType = void> = ThunkAction<ThunkReturnType, RootState, unknown, Action>;
